module.exports = __webpack_public_path__ + "img/freedom.1d56a2bf.png";